import { Flex } from '@mantine/core';
import { LegendProps } from 'recharts';
import { LineChartLegendItem } from '../../../components/line-chart/line-chart-legend-item';
import { getItemColor } from './initiative-progress-chart.helpers';

type Props = LegendProps & {
  hoveredItem: string | null;
  setHoveredItem: (item: string | null) => void;
};

export const InitiativeProgressChartLegend = ({ hoveredItem, setHoveredItem, ...props }: Props) => {
  const { payload } = props;

  if (!payload) {
    return null;
  }

  return (
    <Flex justify="center" align="center" gap="md" h="100%">
      {payload.map((entry) => {
        const itemId = String(entry.dataKey || '');
        const color = getItemColor(itemId, entry.color);
        const isHovered = hoveredItem === null || hoveredItem === itemId;

        return (
          <LineChartLegendItem
            key={`legend-item-${itemId}`}
            value={itemId}
            label={entry.value || ''}
            color={color}
            isHovered={isHovered}
            onMouseEnter={setHoveredItem}
            onMouseLeave={() => setHoveredItem(null)}
          />
        );
      })}
    </Flex>
  );
};
